import React from 'react';
import { services, translations } from '../data/mock';
import { Smartphone, Laptop, Cpu, Sparkles, ArrowUpCircle } from 'lucide-react';

const iconMap = {
  Smartphone,
  Laptop,
  Cpu,
  Sparkles,
  ArrowUpCircle
};

const ServicesSection = () => {
  const t = translations.services;

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4">
            {t.label}
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            {t.title}
          </h2>
          <p className="text-lg text-gray-600">
            {t.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group relative bg-gray-50 hover:bg-white rounded-2xl p-8 transition-all duration-300 hover:shadow-xl hover:shadow-gray-200/50 border border-transparent hover:border-gray-100"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-white group-hover:bg-gray-900 rounded-xl flex items-center justify-center mb-6 transition-colors duration-300 shadow-sm">
                  {IconComponent && (
                    <IconComponent className="w-7 h-7 text-gray-900 group-hover:text-white transition-colors duration-300" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>

                {/* Hover Arrow */}
                <div className="absolute bottom-8 right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </div>
                </div>
              </div>
            );
          })}

          {/* Free Diagnostics Card */}
          <div className="group relative bg-gray-900 rounded-2xl p-8 text-white overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0" style={{
                backgroundImage: `radial-gradient(circle at 2px 2px, white 1px, transparent 0)`,
                backgroundSize: '24px 24px'
              }} />
            </div>

            <div className="relative">
              <div className="w-14 h-14 bg-white/10 rounded-xl flex items-center justify-center mb-6">
                <span className="text-2xl font-bold">0</span>
              </div>
              <h3 className="text-xl font-semibold mb-3">
                {t.freeDiagnosticsTitle}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {t.freeDiagnosticsDesc}
              </p>
              <div className="mt-6 inline-flex items-center gap-2 text-emerald-400 font-medium">
                <span>{t.alwaysFree}</span>
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
